import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { fadeIn, fadeInDown } from '@shared/animations';
import { PageComponent } from '@app/shared/models/page-component';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss'],
  animations: [fadeInDown, fadeIn],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordPageComponent extends PageComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
